<template>
  <div class="box-header" :class="{ 'no-header': !title }">
    <div
      class="box-header-container lg:flex justify-between items-center"
      v-if="title && name && lastName"
    >
      <div class="flex">
        <p class="parragraph-h-20 mr-2" v-html="name"></p>
        <p class="parragraph-h-20" v-html="lastName"></p>
      </div>
      <div>
        <p class="parragraph-h-20" v-html="title"></p>
      </div>
    </div>
    <div class="box-container" v-else>
      <p class="parragraph-h-20" v-html="title"></p>
    </div>
    <div class="box-container">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    name: {
      type: String
    },
    lastName: {
      type: String
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../sass/variables";

.box-header {
  overflow: hidden;
  background-color: $white;
  border-radius: 15px;
  border: 1px solid $brownGrey;
  &-container {
    padding: 1.8rem 16px;
    &:first-of-type {
      padding-top: 1.1rem;
      padding-bottom: 1.1rem;
      border-bottom: 1px solid $brownGrey;
    }
    @media (min-width: 640px) {
      padding: 1.8rem 2.2rem;
    }
  }
  &.no-header {
    .box-container:first-of-type {
      border-bottom: none;
    }
  }
}
</style>
